// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"node_modules_dompurify_dist_purify_es_mjs":"c005cf1369f42242","node_modules_canvg_lib_index_es_js":"6e8964a9de3ee0f0"}[chunkId] + ".js";
};